<template>
  <section>
    <h2>{{ $t('login.contact-label') }}</h2>

    <div class="contact-group">
      <Remixicon name="ri-mail-line" />
      <a class="button-link"
         :href="'mailto:' + email + '?subject=' + $t('ewn.support-email-subject')">
        {{ email }}
      </a>
    </div>

    <div class="contact-group">
      <Remixicon name="ri-customer-service-2-line" />
      <a class="button-link" :href="'tel:' + phone">
        {{ phone }}
      </a>
    </div>

    <button type="button" class="link" @click="$router.back()">
      {{ $t('login.return-button') }}
    </button>
  </section>
</template>

<script>
  import { computed, defineComponent } from 'vue';
  import { useI18n } from '@/i18n';
  import Remixicon from '@/modules/icons/components/Remixicon';
  import { useStore } from '@/store';

  export default defineComponent({
    name: 'ContactUs',
    components: {
      Remixicon
    },
    setup () {
      const i18n = useI18n();
      const store = useStore();
      const isBranded = computed(() => store.state.branding.isBranded);
      const isBrandingLoaded = computed(() => store.state.branding.isBrandingLoaded);

      return {
        email: computed(() => {
          if (!isBrandingLoaded.value) return '--';
          const email = isBranded.value
            ? store.state.branding.branding?.contactEmail
            : null;
          return email || i18n.t('ewn.support-email');
        }),
        phone: computed(() => {
          if (!isBrandingLoaded.value) return '--';
          const phone = isBranded.value
            ? store.state.branding.branding?.contactPhone
            : null;
          return phone || i18n.t('ewn.support-phone');
        })
      };
    }
  });
</script>

<style lang="scss" scoped>
  section {
    max-width: 300px;
  }

  h2 {
    margin-bottom: 16px;
    text-align: center;
  }

  .contact-group {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 16px;
  }

  svg {
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 auto;
  }
</style>
